import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CertificationStatusService } from '@vanguard/cert-layer/dist/cert-layer.umd';
import { firstValueFrom, Subject } from 'rxjs';

import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CertificationService {
  private readonly USER_STATUS_URL = environment.user_status_endpoint;

  // Observable to notify when certification status changes
  private certificationStatusChanged = new Subject<boolean>();
  public certificationStatusChanged$ = this.certificationStatusChanged.asObservable();

  // Local flag to track if user has been certified in this session
  private sessionCertified = false;

  constructor(private http: HttpClient) {}

  // Method to notify that certification was successful
  notifyCertificationSuccess(): void {
    this.sessionCertified = true;
    this.certificationStatusChanged.next(true);
  }

  // Getter to access session certification status without triggering checks
  get isSessionCertified(): boolean {
    return this.sessionCertified;
  }

  async updateCertificationStatus(): Promise<boolean> {
    if (this.sessionCertified) {
      return true;
    }

    const isCertified = !!(
      environment.UserLocation === 'internal' ||
      CertificationStatusService.getCookieData() ||
      (await this.checkLoginStatus())
    );
    this.sessionCertified = this.sessionCertified || isCertified;
    return this.sessionCertified;
  }

  /**
   * Check login status by calling the user-status endpoint
   * @returns Promise<boolean> - true if user is certified (200), false if not (401 or error)
   */
  async checkLoginStatus(): Promise<boolean> {
    try {
      const response: any = await firstValueFrom(
        this.http.get(this.USER_STATUS_URL, { observe: 'response' }),
      );
      return response && response.status === 200;
    } catch (error: any) {
      return false;
    }
  }
}
